import {
  SystemCodeArea,
  SystemCodeAreaFromJSON,
  UpdateSystemCodeAreaRequest,
  UpdateSystemCodeAreaRequestToJSON
} from '@/api'
import * as runtime from '../runtime'

export class SystemCodeAreaApi extends runtime.BaseAPI {
  async getAllSystemCodeArea(code: string = ''): Promise<SystemCodeArea[]> {
    const queryParameters: runtime.HTTPQuery =
      code !== ''
        ? {
            code
          }
        : {}

    const response = await this.requestGet(
      '/system-code-areas',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SystemCodeAreaFromJSON)
    ).value()
  }

  async updateSystemCodeArea(
    request: UpdateSystemCodeAreaRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateSystemCodeAreaRequestToJSON(
      request
    )
    const response = await this.requestPut('/system-code-areas', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }
}
